import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DiscoverTournamentsState {
  isCtaHidden: boolean;
}

const initialState: DiscoverTournamentsState = {
  isCtaHidden: false,
};

const discoverTournamentsSlice = createSlice({
  name: 'discoverTournaments',
  initialState,
  reducers: {
    setCtaHidden: (state, action: PayloadAction<boolean>) => {
      state.isCtaHidden = action.payload;
    },
    hideCta: (state) => {
      state.isCtaHidden = true;
    },
    showCta: (state) => {
      state.isCtaHidden = false;
    },
  },
});

export const { setCtaHidden, hideCta, showCta } = discoverTournamentsSlice.actions;
export default discoverTournamentsSlice.reducer;
